import { useParams } from "react-router-dom";
import DoctorLayout from "@/pages/doctor/DoctorLayout";
import PatientProfileContent from "@/components/PatientProfileContent";

export default function DoctorPatientProfilePage() {
  const { patientId } = useParams();
  return (
    <DoctorLayout>
      <PatientProfileContent patientId={patientId} />
    </DoctorLayout>
  );
}
